import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UiMeet3dActivityLog from "~/models/UiMeet3d/UiMeet3dActivityLog";

@observer
class UiMeet3dActivityLogTable extends Component {
  render() {
    const { uiMeet3dActivityLogs, t } = this.props;

    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("clientPanelMisc:tour")}</Table.HeaderCell>
            <Table.HeaderCell>{t("duration")}</Table.HeaderCell>
            <Table.HeaderCell>{t("date")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {uiMeet3dActivityLogs.length === 0 && (
            <Table.Row>
              <Table.Cell colSpan={4} textAlign="center">
                <p>{t("clientPanelMisc:noRecordedMeeting")}</p>
              </Table.Cell>
            </Table.Row>
          )}
          {uiMeet3dActivityLogs.length > 0 &&
            uiMeet3dActivityLogs.map(uiMeet3dActivityLog => (
              <Table.Row key={uiMeet3dActivityLog.uiMeet3dActivityLogId}>
                <Table.Cell>
                  <Link to={`/tours/${uiMeet3dActivityLog.tourId}`}>{uiMeet3dActivityLog.tourId}</Link>
                </Table.Cell>
                <Table.Cell>{uiMeet3dActivityLog.durationDescription}</Table.Cell>
                <Table.Cell>{uiMeet3dActivityLog.activityDts.format("llll")}</Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    );
  }
}

UiMeet3dActivityLogTable.propTypes = {
  t: PropTypes.func.isRequired,
  uiMeet3dActivityLogs: PropTypes.arrayOf(PropTypes.instanceOf(UiMeet3dActivityLog)),
};

export default withTranslation()(UiMeet3dActivityLogTable);
